import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppSelector } from "../../../hooks/store-hooks"
import { useProdutoService } from "../../../../use-cases/produto"
import { IdProdutoImgMap } from "../../../assets/helpers"

export const AutoRedirectToModule = () => {
  const { modules } = useAppSelector((state) => state.user)
  const navigate = useNavigate()
  const { getProdutosByIdUsuarioAndSetModules } = useProdutoService()

  useEffect(() => {
    getProdutosByIdUsuarioAndSetModules()
  }, [getProdutosByIdUsuarioAndSetModules])

  useEffect(() => {
    const handleAutoRedirect = () => {
      if (modules.length > 0) {
        // Priorizar o redirecionamento para o Geo Veles (ID 6) se disponível
        const geoVelesModule = modules.find(m => m.IdProduto === 6)
        const firstModule = geoVelesModule || modules[0]
        
        const moduleUrl = IdProdutoImgMap.find((img) => img.id === firstModule.IdProduto)?.url
        
        if (moduleUrl) {
          navigate(moduleUrl, { replace: true })
        }
      }
    }

    handleAutoRedirect()
  }, [modules, navigate])
  
  return <></>
}
